import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.normalizeScroll(true);

const homeVideoMobile = () => {
	const sectionWrapper = document.querySelector(".jbg-home-video-mobile");
	if (!sectionWrapper) return;

	const slides = gsap.utils.toArray(".jbg-home-video-mobile-slide");

	// Wait for GSAP to render pin-spacer
	requestAnimationFrame(() => {
		const pinSpacers = document.querySelectorAll(".pin-spacer");
		const lastPinSpacer = pinSpacers[pinSpacers.length - 1];
		if (!lastPinSpacer || !lastPinSpacer.parentNode) return;

		const spacer = document.createElement("div");
		spacer.className = "jbg-home-video-mobile-spacer";
		Object.assign(spacer.style, {
			height: "100svh",
			pointerEvents: "none",
		});

		lastPinSpacer.parentNode.insertBefore(
			spacer,
			lastPinSpacer.nextSibling
		);
	});

	slides.forEach((slide, index) => {
		ScrollTrigger.create({
			trigger: slide,
			start: "top top",
			end: "bottom top",
			pin: true,
			pinSpacing: false,
		});

		if (index !== 0) {
			gsap.set(slide, { autoAlpha: 0 });

			gsap.to(slide, {
				autoAlpha: 1,
				duration: 0.5,
				ease: "power1.out",
				scrollTrigger: {
					trigger: slide,
					start: "top top",
					end: "top center",
					toggleActions: "play none none reverse",
				},
			});
		}
	});

	const logos = gsap.utils.toArray(".jbg-home-video-mobile__content");

	logos.forEach((logo, i) => {
		gsap.set(logo, {
			yPercent: 100,
			top: `${i * 100}svh`,
		});
	});

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: sectionWrapper,
			start: "top top",
			end: "bottom top",
			scrub: true,
		},
	});

	logos.forEach((logo) => {
		tl.fromTo(logo, { yPercent: 100 }, { yPercent: -100, ease: "none" });
	});
};

export default homeVideoMobile;
